import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Header } from './Header';
import { ConnectionStatus } from './ConnectionStatus';
import { DesktopStage } from './DesktopStage';
import { runtime } from '@/platform/runtime';
import { ensureConnected } from '@/api/signalr';
import { useStore } from '@/app/StoreContext';
import { ScreenTransition, useScreenDirection } from '@/components/transitions/ScreenTransition';
import { OnboardingRoot } from '@/components/onboarding/OnboardingRoot';
import styles from './AppShell.module.css';

// Normalize pathname for direction: all /r/:code routes collapse to '/r/'
function normalizeRoute(pathname: string): string {
  return pathname.startsWith('/r/') ? '/r/' : '/';
}

const ROUTE_ORDER = ['/', '/r/'] as const;

export function AppShell() {
  const { auth } = useStore();
  const location = useLocation();
  const direction = useScreenDirection(normalizeRoute(location.pathname), ROUTE_ORDER);

  useEffect(() => {
    if (auth.isAuthenticated) void ensureConnected();
  }, [auth.isAuthenticated]);

  return (
    <div className={styles.shell}>
      <ConnectionStatus />
      {!runtime.isMiniApp && <Header />}
      <DesktopStage>
        <main className={styles.main}>
          <ScreenTransition motionKey={location.pathname} direction={direction}>
            <Outlet />
          </ScreenTransition>
        </main>
      </DesktopStage>
      <OnboardingRoot />
    </div>
  );
}
